<template>
  <div>
    <Header navTitle="提报工时履历" navTip="系统发现你参与案件中存在未报情况，请及时处理！"></Header>
    <div class="calendar">
      <van-calendar
        v-if="isShow"
        :poppable="false"
        :show-confirm="false"
        color="#5374e6"
        row-height="50"
        @select="onSelect"
        :min-date="
          new Date(
            minDate ||
              `${new Date().getFullYear()}/${new Date().getMonth() + 1}/1`
          )
        "
        :show-title="false"
        :style="{ height: '100%' }"
        :formatter="formatter"
      />
    </div>
  </div>
</template>
<script lang="ts">
import Header from '@/components/header.vue';
import { defineComponent, ref } from 'vue';
import { Calendar } from 'vant';
import getInfo from '@/http/calenDar';
import router from '@/router';

export default defineComponent({
  components: {
    [Calendar.name]: Calendar,
    Header,
  },
  setup() {
    const dataList: any = ref([]);
    const isShow = ref(false);
    const minDate = ref('');
    getInfo().then((res: any) => {
      dataList.value = res.result;
      minDate.value = res.result[0] ? res.result[0].replace(/-/g, '/') : '';
      isShow.value = true;
    });
    const formatter = (day: any) => {
      // console.log(dataList.value.length);
      const data = day;
      const stingdate: any = `${data.date.getFullYear()}-${
        data.date.getMonth() + 1
      }-${data.date.getDate()}`;
      // console.log(stingdate);
      if (dataList.value.includes(stingdate)) {
        data.bottomInfo = 'ng';
        data.className = 'ng';
      }
      return data;
    };
    // 日期选择
    const onSelect = (data: any) => {
      console.log(data);
      const stingdate: any = `${data.getFullYear()}-${
        data.getMonth() + 1
      }-${data.getDate()}`;
      if (dataList.value.includes(stingdate)) {
        router.push({ path: '/addCase', query: { date: stingdate } });
      }
    };
    return {
      formatter,
      dataList,
      onSelect,
      isShow,
      minDate,
    };
  },
});
</script>

<style lang="scss" scoped>
/deep/.ng {
  .van-calendar__bottom-info {
    background: red;
    width: 25px;
    margin: auto;
    border-radius: 20px;
    bottom: 3px;
    color: #fff;
  }
}
.calendar {
  position: absolute;
  height: calc(100% - 100px);
  overflow: auto;
}
</style>
